export default {
  id: null,
  name: '',
  email: '',
  username: '',
  permission: {},
  mqttToken: null,
  token: {},
  telegram: {},
  avatar: null,
  apiToken: '',
  homeDepotId: '',
  betaAccess: false,
  dashboardConfiguration: {
    dashboardWidgets: []
  },
  timeZone: '',
  endAt: null
}